import {setCookie} from './../util/coockie'
import makeRequest from './../util/makeRequest'

export const CHANGE_SELECTED_DOCTYPE = 'CHANGE_SELECTED_DOCTYPE';
export const CHANGE_SELECTED_LEVEL = 'CHANGE_SELECTED_LEVEL';
export const CHANGE_SELECTED_URGENCY = 'CHANGE_SELECTED_URGENCY';
export const CHANGE_SELECTED_CURRENCY = 'CHANGE_SELECTED_CURRENCY';
export const CHANGE_SELECTED_COVER_LETTERS = 'CHANGE_SELECTED_COVER_LETTERS';
export const SELECT_VAS = 'SELECT_VAS';
export const CANCEL_VAS = 'CANCEL_VAS';
export const CHANGE_VAS_ITEMS = 'CHANGE_VAS_ITEMS';
export const CHANGE_DISCOUNT_CODE = 'CHANGE_DISCOUNT_CODE';
export const CLEAR_DISCOUNT_CODE = 'CLEAR_DISCOUNT_CODE';
export const BACK_TO_ORDER_DETAILS_FORM = 'BACK_TO_ORDER_DETAILS_FORM';
export const GO_TO_PERSONAL_INFO_FORM = 'GO_TO_PERSONAL_INFO_FORM';
export const SEND_VALIDATE_FORM_REQUEST = 'SEND_VALIDATE_FORM_REQUEST';
export const RECEIVE_VALIDATE_FORM_RESPONSE = 'RECEIVE_VALIDATE_FORM_RESPONSE';
export const CHANGE_SELECTED_COUNTRY = 'CHANGE_SELECTED_COUNTRY';
export const CHANGE_TARGET_POSITION = 'CHANGE_TARGET_POSITION';
export const CHANGE_NAME = 'CHANGE_NAME';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const CHANGE_RETYPE_EMAIL = 'CHANGE_RETYPE_EMAIL';
export const CHANGE_PHONE_NUMBER = 'CHANGE_PHONE_NUMBER';
export const CHANGE_PAYMENT_METHOD = 'CHANGE_PAYMENT_METHOD';
export const CHANGE_ACCEPT_TERMS = 'CHANGE_ACCEPT_TERMS';
export const SEND_CHECK_DISCOUNT_REQUEST = 'SEND_CHECK_DISCOUNT_REQUEST';
export const RECEIVE_CHECK_DISCOUNT_RESPONSE = 'RECEIVE_CHECK_DISCOUNT_RESPONSE';

export const changeSelectedDoctype = (doctypeId) => ({
    type: CHANGE_SELECTED_DOCTYPE,
    doctypeId
});
export const changeSelectedLevel = (levelName) => ({
    type: CHANGE_SELECTED_LEVEL,
    levelName
});
export const changeSelectedUrgency = (urgencyId) => ({
    type: CHANGE_SELECTED_URGENCY,
    urgencyId
});
export const changeCurrency = (currency) => ({
    type: CHANGE_SELECTED_CURRENCY,
    currency
});
export const changCoverLetters = (coverLetters) => ({
    type: CHANGE_SELECTED_COVER_LETTERS,
    coverLetters
});
export const selectVas = (vasId) => ({
    type: SELECT_VAS,
    vasId
});
export const cancelVas = (vasId) => ({
    type: CANCEL_VAS,
    vasId
});
export const changeVasItems = (vasId, itemsCount) => ({
    type: CHANGE_VAS_ITEMS,
    vasId,
    itemsCount
});
export const changeDiscountCode = (discountCode) => ({
    type: CHANGE_DISCOUNT_CODE,
    discountCode
});
export const clearDiscountCode = () => ({
    type: CLEAR_DISCOUNT_CODE
});
export const changeSelectedCountry = (countryId) => ({
    type: CHANGE_SELECTED_COUNTRY,
    countryId
});
export const changeTargetPosition = (value) => ({
    type: CHANGE_TARGET_POSITION,
    value
});
export const changeName = (value) => ({
    type: CHANGE_NAME,
    value
});
export const changeEmail = (value) => ({
    type: CHANGE_EMAIL,
    value
});
export const changeRetypeEmail = (value) => ({
    type: CHANGE_RETYPE_EMAIL,
    value
});
export const changePhoneNumber = (value) => ({
    type: CHANGE_PHONE_NUMBER,
    value
});
export const changePaymentMethod = (paymentType) => ({
    type: CHANGE_PAYMENT_METHOD,
    paymentType
});
export const changeAcceptTerms = () => ({
    type: CHANGE_ACCEPT_TERMS
});
export const backToOrderDetailsForm = () => ({
    type: BACK_TO_ORDER_DETAILS_FORM,
});
export const goToPersonalInfoForm = () => ({
    type: GO_TO_PERSONAL_INFO_FORM,
});
export function checkDiscount(email, discount, numpages, doctypeId, wrlevelId, urgencyId, categoryId = null, orderCode = null, loadDoctypes = 0, topic= '', numpapers = 0) {
    return dispatch => {

        dispatch(sendCheckDiscountRequest())

        //const response = {"coefficient":{"29":0.1,"30":0.1,"31":0.1,"32":0.1,"33":0.1,"34":0.1,"50":0.1,"133":0.1,"137":0.1,"138":0.1,"259":0.1,"330":0.1,"331":0.1,"332":0.1,"333":0.1,"334":0.1,"335":0.1,"336":0.1},"coefficient_type":0}
        //const response = {"coefficient":0.1,"coefficient_type":0}
        //dispatch(receiveCheckDiscountResponse(10))

        return makeRequest({
                method: 'GET',
                url: '/order.check-promo-code/'
                + email + '/'
                + discount + '/'
                + numpages + '/'
                + doctypeId + '/'
                + wrlevelId + '/'
                + urgencyId + '/'
                + categoryId + '/'
                + orderCode + '/'
                + loadDoctypes + '/'
                + topic,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                }
            })
            .then(response => JSON.parse(response))
            .then(response => {
                let discountPercent = 0
                if (response.coefficient) {
                    if (typeof response.coefficient === 'object' && action.response.coefficient[state.selectedDoctypeId]) {
                        discountPercent = response.coefficient[state.selectedDoctypeId] * 100
                    } else {
                        discountPercent = response.coefficient * 100
                    }
                }

                if (discountPercent > 0) {
                    setCookie('not-used-discount', discount, 1)
                } else {
                    setCookie('not-used-discount', discount, -1)
                }

                dispatch(receiveCheckDiscountResponse(discountPercent))
            })
    }
}
function sendCheckDiscountRequest() {
    return {
        type: SEND_CHECK_DISCOUNT_REQUEST
    }
}
function receiveCheckDiscountResponse(discountPercent) {

    return {
        type: RECEIVE_CHECK_DISCOUNT_RESPONSE,
        discountPercent
    }
}

export function validateForm(data) {
    return dispatch => {
        dispatch(sendValidateFormRequest())

        // const response = {
        //     country: true,
        //     doctype: true,
        //     email: true,
        //     name: true,
        //     phone1: true,
        //     phone1_number: true,
        //     retype_email: true,
        //     urgency: true,
        // }
        //
        // dispatch(receiveValidateFormResponse(response))

        return makeRequest({
                method: 'POST',
                url: '/order.validate',
                params: data,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then(response => JSON.parse(response))
            .then(response => dispatch(receiveValidateFormResponse(response)))
    }
}

function sendValidateFormRequest() {
    return {
        type: SEND_VALIDATE_FORM_REQUEST
    }
}
function receiveValidateFormResponse(response) {

    return {
        type: RECEIVE_VALIDATE_FORM_RESPONSE,
        response
    }
}

